import firebase from 'firebase'

const SCHEMA_NAME = "programPageContent"

export async function getProgramPageContent() {

    let output = {}
    let collection = firebase.firestore().collection("fl_content").where('_fl_meta_.schema', '==', SCHEMA_NAME);

    await collection.get().then(async (querySnapshot) => {
        await Promise.all(querySnapshot.docs.map(async (doc) => {
            output = {
                pageHeader: doc.data().pageHeader,
                videoUrl: doc.data().videoUrl,
                subHeader: doc.data().subHeader,
                bodyText: doc.data().bodyText
            }
        }));
    });

    return output;
}